<div class="meeting-card" [ngClass]="{ 'upcoming-card': type === 'upcoming' }">
  <div
    class="meeting-icon"
    [ngClass]="{ 'upcoming-icon': type === 'upcoming' }"
  >
    <div class="i-meeting" [ngClass]="{ 'i-upcoming': type === 'upcoming' }">
      {{
        meeting?.meetingDate | date : "dd"
      }}
    </div>
    <p class="date">{{
      meeting?.meetingDate | date : "MMM yyyy"
    }}</p>
  </div>
  <div class="message">
    <ng-container *ngIf="type === 'upcoming'">
      <label class="upcoming">Upcoming Meeting</label>
    </ng-container>
    <label class="meeting-name" *ngIf="type === 'past'" (click)="openDetailsModal()" aria-label="Open Meeting Details modal" [motif-tooltip]="meeting.name" [hideOnScroll]="true" placement="top"
      >{{ meeting?.name }}
    </label>
    <div class="meeting-action">
      <label> 6 Action items</label>
      <motif-icon (click)="openActionsModal()" [src]="'/assets/icons/file/ic_file_download_24px.svg'" fill="red" stroke="blue" strokeWidth="4" size="24"></motif-icon>
    </div>
  </div>
</div>
